<template>
  <v-container fluid>
    <v-tabs color="secondary">
      <v-tab>Users</v-tab>
      <v-tab-item>
        <Users></Users>
      </v-tab-item>
      <v-tab>Divisions</v-tab>
      <v-tab-item>
        <Divisions></Divisions>
      </v-tab-item>
      <v-tab>Import Bills</v-tab>
      <v-tab-item>
        <ImportBills></ImportBills>
      </v-tab-item>
      <!-- <v-tab>Bill Tracker</v-tab>
      <v-tab-item>
        <TrackedBill></TrackedBill>
      </v-tab-item> -->
      <!-- <v-tab>Users2</v-tab>
        <v-tab-item>
          <Users></Users>
        </v-tab-item>-->
    </v-tabs>
  </v-container>
</template>
<script>
import Users from '@components/agencyAdmin/UserGrid'
import Divisions from '@components/agencyAdmin/LuAgencyDivisionGrid'
import ImportBills from '@components/agencyAdmin/ImportBills'
export default {
  page: {
    title: 'Agency Administration',
  },
  //model: {
  //	prop: ''
  //},
  props: {},
  components: { Users, ImportBills, Divisions },
  filters: {},
  data() {
    return {}
  },
  created() {},
  computed: {},
  methods: {},
  watch: {},
}
</script>
<style scoped></style>
